import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./components/main/App";
import ErrorBoundary from "./components/main/ErrorBoundary";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <App />
                </PersistGate>
            </Provider>
        </ErrorBoundary>
    </React.StrictMode>
);
